import moment from 'moment'

import { enableCard } from '../actions'
import { CARDS } from '../reducers'
import { startOfWeekSelector } from '@settings/selectors'
import { fetchEvents, setEvent, removeEvent } from 'search/actions'
import { selectedEventSelector, eventsListSelector, eventsSearchPendingSelector } from 'search/selectors'
import { makePurchasePendingSelector } from 'basket/selectors'

import { FormattedNumber } from 'i18n'
import { withRouter } from 'i18n/utils'
import { currencyFromSymbol } from 'shared/currency-utilities'
import { DateTimeRange, DateRange } from 'shared/components/TimePicker'
import { CardSection } from '@components/CardSection'
import CircleLoader from '@components/CircleLoader'
import Button from '@components/Button'
import RateList from './RateList/RateList'
import ErrorMessage from '@components/ErrorMessage'
import IconButton from '@components/IconButton'

const EventsSelection = ({
    selectedEvent,
    startOfWeek,
    enableCard,
    grsId,
    fetchEvents,
    setEvent,
    removeEvent,
    eventsList,
    eventsSearchPending,
    makePurchasePending,
}) => {
    const [selectedRate, setSelectedRate] = React.useState(selectedEvent)

    React.useEffect(() => {
        fetchEvents({ locationId: grsId })
        enableCard([CARDS.CONFIRM_VEHICLE, CARDS.PAY_FOR_PARKING])
    }, [])

    const onDateInputChange = (startDate, endDate) => {
        fetchEvents({ startDate, endDate, locationId: grsId })
    }

    const onSelectRateHandler = rate => {
        setSelectedRate(rate)
    }

    const confirmSelectionHandler = () => {
        setEvent(selectedRate)
    }

    const onEditHandler = () => {
        removeEvent()
    }

    return (
        <>
            <CardSection
                className="search-bar confirm"
                title={<T>booking.event.parking</T>}
                header={() =>
                    selectedEvent ? (
                        <IconButton onClick={onEditHandler} icon={'edit'} label={<T>booking.event.edit</T>} />
                    ) : null
                }>
                {selectedEvent ? (
                    <>
                        <div className="d-flex mb-5">
                            <div>
                                <p className="font-weight-bold m-0">{selectedEvent.eventName}</p>
                                {selectedEvent.eventShortDescription && (
                                    <div
                                        className="mt-2"
                                        dangerouslySetInnerHTML={{ __html: selectedEvent.eventShortDescription }}
                                    />
                                )}

                                {selectedEvent.eventMoreInfo && (
                                    <div
                                        className="mt-2"
                                        dangerouslySetInnerHTML={{ __html: selectedEvent.eventMoreInfo }}
                                    />
                                )}
                            </div>

                            <div className="ml-auto text-right">
                                <p className="font-weight-bold">
                                    <FormattedNumber
                                        value={selectedEvent.price}
                                        style="currency"
                                        currency={currencyFromSymbol(selectedEvent.currencySymbol)}
                                    />
                                </p>
                                <p className="small m-0">{selectedEvent.rateName}</p>
                            </div>
                        </div>
                        <DateTimeRange
                            startOptions={{
                                datePickerOptions: {
                                    label: <T>label.parking.start</T>,
                                    readOnly: true,
                                    alwaysShowIcon: true,
                                },
                                timePickerOptions: {
                                    label: <T>label.datetime.info</T>,
                                    readOnly: true,
                                    alwaysShowIcon: true,
                                },
                            }}
                            endOptions={{
                                datePickerOptions: {
                                    label: <T>label.parking.end</T>,
                                    readOnly: true,
                                    alwaysShowIcon: true,
                                },
                                timePickerOptions: {
                                    label: <T>label.datetime.info</T>,
                                    readOnly: true,
                                    alwaysShowIcon: true,
                                },
                            }}
                            startOfWeek={startOfWeek}
                            start={moment(selectedEvent.fromDate)}
                            end={moment(selectedEvent.toDate)}
                        />
                    </>
                ) : (
                    <div>
                        <div className="row align-items-end mb-4">
                            <div className="col-sm-3">
                                <T>events.search.modal.date.range</T>
                            </div>
                            <div className="col-sm-6 mt-2">
                                <DateRange
                                    clear
                                    onChange={onDateInputChange}
                                    startOptions={{
                                        label: <T>events.search.modal.date.range.start</T>,
                                    }}
                                    endOptions={{
                                        label: <T>events.search.modal.date.range.end</T>,
                                    }}
                                />
                            </div>
                        </div>
                        {eventsSearchPending ? (
                            <div className="row justify-content-center m-6">
                                <CircleLoader />
                            </div>
                        ) : eventsList.length > 0 ? (
                            <RateList
                                event
                                selectRate={onSelectRateHandler}
                                rates={eventsList}
                                selectedRateId={selectedRate ? selectedRate.rateId : null}
                                disabled={makePurchasePending === true}
                            />
                        ) : (
                            <ErrorMessage messages={[<T>booking.event.no.results</T>]} />
                        )}

                        <div className="col-xs-12 col-sm-3">
                            <Button
                                size="large"
                                block
                                onClick={confirmSelectionHandler}
                                disabled={!selectedRate || eventsList.length === 0}>
                                <T>booking.event.edit.confirm</T>
                            </Button>
                        </div>
                    </div>
                )}
            </CardSection>
        </>
    )
}

export default compose(
    withRouter,
    connect(
        createStructuredSelector({
            startOfWeek: startOfWeekSelector,
            selectedEvent: selectedEventSelector,
            eventsList: eventsListSelector,
            eventsSearchPending: eventsSearchPendingSelector,
            makePurchasePending: makePurchasePendingSelector,
        }),
        {
            enableCard,
            fetchEvents,
            setEvent,
            removeEvent,
        }
    )
)(EventsSelection)
